module.exports = "/assets/data/5d1fb702ec8ed4ed6fc70dde2707cd66-IP12.data.json";